export const AVAILABILITY_THRESHOLD_STEP = 10;
